export default function EditHardwareAndSchematicsDialogController(
  $q,
  ssDialogService,
  loaderService // eslint-disable-line no-unused-vars
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditHardwareAndSchematicsDone = _handleEditHardwareAndSchematicsDone;
  vm.handleChangedSchematicCount = _handleChangedSchematicCount;
  vm.handleChangedWorkstationCount = _handleChangedWorkstationCount;
  vm.handleChangedServerCount = _handleChangedServerCount;

  /** ************************************************
   * Event Handlers
   */

  function _handleChangedSchematicCount() {
    vm.changedAssetCountCallback('schematics');
  }

  function _handleChangedWorkstationCount() {
    vm.changedAssetCountCallback('workstations');
  }

  function _handleChangedServerCount() {
    vm.changedAssetCountCallback('servers');
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditHardwareAndSchematicsDone() {
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editHardwareAndSchematicsDialog);
  }
}

EditHardwareAndSchematicsDialogController.$inject = [
  '$q',
  'ssDialogService',
  'loaderService'
];
